import { Partial } from '@40seas/entities/common';
import { BankAccount } from './bank-account.entity';

export class UpdateBankAccountDto extends Partial(BankAccount) {}
